/* eslint-disable import/no-named-as-default */
import React, {
} from 'react'
import {
  Routes, Route,
} from 'react-router-dom'
import Page from 'src/components/Page'
import {
  makeStyles,
} from '@material-ui/core'
import withWidth from '@material-ui/core/withWidth'
import Exam from 'src/components/Exam'
import ExamUser from './ExamUser'
import UserPackage from './UserPackage'
import DiscTest from './DiscTest'

const useStyle = makeStyles((theme) => ({
  root: {
    padding: 10,
  },
  title: {
    marginBottom: 15,
  },
  icon: {
    marginRight: 10,
  },
  list: {
    borderRadius: theme.spacing(1.25),
    boxShadow: '0 0 1px 0 rgba(26, 24, 24, 0.2)',
    backgroundColor: '#fff',
    marginBottom: theme.spacing(3.7),
  },
  listTitle: {
    fontSize: theme.spacing(2.5),
    fontWeight: 500,
    color: '#494949',
  },
  listItemData: {
    maxWidth: '30%',
    textAlign: 'center',
  },
  listItemPrimary: {
    fontSize: theme.spacing(2),
    fontWeight: 'normal',
    color: '#585858',
  },
  listItemPackageName: {
    textAlign: 'left',
  },
  packageStatus: {
    display: 'inline',
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(1),
  },
  pay_pending: {
    backgroundColor: '#e4006a',
  },
  paid: {
    backgroundColor: '#ff9200',
  },
  inprogress: {
    backgroundColor: '#ff9200',
  },
  completed: {
    backgroundColor: '#11a700',
  },
  expired: {
    backgroundColor: '#7D00B1',
  },
  resultReady: {
    backgroundColor: '#0090FF',
  },
  packageStatusText: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
    color: '#ffffff',
  },
  btn: {
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(0.9),
    backgroundColor: '#405df0',
    margin: '1rem 1rem 0 auto',
    display: 'flex',
    '&:hover': {
      backgroundColor: '#10279b',
    },
  },
  expandBtn: {
    margin: '1rem 1rem 0 auto',
    display: 'flex',
  },
  btnLabel: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
    color: '#fff',
  },
  containerPortal: {
    maxWidth: theme.spacing(110),
    margin: 'auto',
  },
  expandLessIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: theme.spacing(4),
    padding: theme.spacing(0, 1),
    borderEndStartRadius: theme.spacing(1),
    borderEndEndRadius: theme.spacing(0.7),
    cursor: 'pointer',
    marginTop: theme.spacing(1),
  },
  ListItemRespansive: {
    borderBottom: '0.5px solid #e7e7e7',
  },
  listItemDataRespansive: {
    textAlign: 'right',
  },
  alertList: {
    marginBottom: theme.spacing(-1),
    borderBottomRightRadius: theme.spacing(1.25),
    borderBottomLeftRadius: theme.spacing(1.25),
  },
}))

export const ExamsUser = () => {
  const classes = useStyle()

  return (
    <Page
      className={classes.root}
      title="آزمون ها"
    >
      <Routes>
        <Route path="/" element={<ExamUser />} />
        <Route path="/:packageId" element={<UserPackage />} />
        <Route path="/:packageId/:examId" element={<DiscTest />} />
        <Route path="/exam/:userExamId/" element={<Exam isUser />} />
        <Route path="/exam/:userExamId/:first" element={<Exam isUser />} />
        <Route path="/exam/:userExamId/:first/:after" element={<Exam isUser />} />
      </Routes>

    </Page>

  )
}

export default withWidth()(ExamsUser)
